import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from "@ngx-translate/core";
import { ResponsiveBarChartRendererComponent } from './responsive-bar-chart-renderer.component';
import { BarChartModule } from '@shared/components/bar-chart/bar-chart.module';

@NgModule({
  declarations: [ ResponsiveBarChartRendererComponent ],
  exports: [ ResponsiveBarChartRendererComponent ],
  imports: [
    CommonModule,
    BarChartModule
  ],
  providers: [
    TranslatePipe
  ]
})
export class ResponsiveBarChartRendererModule { }
